import React, { useEffect, useState } from "react";
import { Tag } from "antd";

const EmployeeBranches = (props) => {
  const { record } = props;
  const [branchNames, setBranchNames] = useState([]);

  useEffect(() => {
    let names = [];
    record.branch_active.forEach(async (item) => {
      const filtered = record.active_branches.filter(
        (branch) => branch.id === item.branch_id
      )[0];
      names.push({ name: filtered.name, isActive: item.active });
    });
    setBranchNames(names);
  }, [record]);

  return (
    <div>
      {branchNames.map((item, i) =>
        item.isActive ? (
          <Tag style={{ margin: "2px 0px" }} key={i}>
            {item.name}
          </Tag>
        ) : (
          <div style={{ opacity: 0.5, margin: "2px 0px" }} key={i}>
            <Tag disabled={true}>{item.name}</Tag>
          </div>
        )
      )}
    </div>
  );
};

export default EmployeeBranches;
